import React from "react";
import LigCustomModal from "../../../../assets/components/LigCustomModal";

const LeaderBoardMessages = ({ show, closeHandler, data }) => {
  const dialogContent = (
    <div className="mt-3">
      {data.map((message, index) => {
        return <p key={index}>{message.desc}</p>;
      })}
    </div>
  );
  return (
    <LigCustomModal
      open={show}
      closeHandler={closeHandler}
      dialogContent={dialogContent}
    />
  );
};

export default LeaderBoardMessages;
